import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import ColorSwatchCheckbox from "./elements/ColorSwatchCheckbox"
import SizeCheckbox from "./elements/SizeCheckbox"
import Icon from "./elements/Icon"
import { useState } from "preact/hooks"

export default function Facet({ facet }) {
    const { selectedFiltersCount, toggleProductFilter } = useFacet(facet)
    const [letterSizesOrder, setLetterSizesOrder] = useState(["xxs", "xxs/xs", "xxs-xs", "xs", "x small", "xs/s", "xs-s", "s", "small", "s/m", "s-m", "m", "medium", "m/l", "m-l", "l", "large", "l/xl", "l-xl", "xl", "x large", "xl/xxl", "xl-xxl", "xxl", "one", "one size"])

    function handleToggle(e){
        const el = e.currentTarget.closest('.ns-sidebar-dropdown');
        el.classList.toggle('ns-active')
    }

    return (
        <li class={`ns-sidebar-dropdown`}>
            <a
                class="ns-filter-name ns-relative ns-w-100 ns-border-box ns-text-undecorated flex justify-between items-center"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={handleToggle}
                data-facet={facet.name}
            >
                <span class="filter-sort__label accordion-header text-16">{facet.name}</span>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                <div class="text-14 accordion-icon">
                </div>
            </a>
            <div class="ns-sidebar-submenu ns-d-none">
            {facet.name === 'Size' 
                ?
                <ul class="ns-filter-options size-option">
                        {facet.data?.sort((a, b) => letterSizesOrder.indexOf(a.value.toLowerCase()) - letterSizesOrder.indexOf(b.value.toLowerCase()))?.map((value) => (
                            <li
                            class="ns-filter-option"
                            data-nosto-element="facet-setting"
                            data-key={value.value.toLowerCase()}
                        >
                            <SizeCheckbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                        </li>
                    ))}
                </ul>
            : facet.name === 'Color'
                ?
                <ul class="ns-filter-options color-option">
                    {facet.data?.map(value => (
                        <li
                            class="ns-filter-option"
                            data-nosto-element="facet-setting"
                            data-key={value.value.toLowerCase()}
                        >
                            <ColorSwatchCheckbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            {/* <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-border-radius-3">
                                ({value.count})
                            </span> */}
                        </li>
                    ))}
                </ul>
                :
                <ul class="ns-filter-options">
                    {facet.data?.map(value => (
                        <li
                            class="ns-filter-option"
                            data-nosto-element="facet-setting"
                            data-key={value.value.toLowerCase()}
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            {/* <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-border-radius-3">
                                ({value.count})
                            </span> */}
                        </li>
                    ))}
                </ul>
                }
            </div>
        </li>
    )
}
